export enum ProfileType {
  AGENT = 'AGENT',
  AGENT_MVP = 'AGENT_MVP',
  CANDIDATE_CONFIRM_OTP_CODE = 'CANDIDATE_CONFIRM_OTP_CODE',
  CANDIDATE_IDENTIFIED_BY_SERVICE = 'CANDIDATE_IDENTIFIED_BY_SERVICE',
  CONTRACT_DRAFT = 'CONTRACT_DRAFT',
  AGENT_PASSED_CHECKING = 'AGENT_PASSED_CHECKING',
  PROCESSING_NOT_AVAILABLE = 'PROCESSING_NOT_AVAILABLE',
  PENDING_SECURITY = 'PENDING_SECURITY',
  DENIED_SECURITY = 'DENIED_SECURITY',
  SIGNING_OVERDUE = 'SIGNING_OVERDUE',
  /** @deprecated Старое значение для 77 договора */
  CONFIRM_SECURITY = 'CONFIRM_SECURITY',
  /** @deprecated Старое значение для 77 договора */
  CONTRACT_DRAFT_FULL = 'CONTRACT_DRAFT_FULL',
}
